module.exports = __webpack_public_path__ + "img/edit.ce1a3c6e.svg";